import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CsrfService } from '../services/CSRFService';

@Injectable()
export class CSRFInterceptor implements HttpInterceptor {
  constructor(private csrfService: CsrfService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const csrfToken = this.getCsrfToken(); // Implement token retrieval

    const modifiedReq = req.clone({
      setHeaders: {
        'X-CSRF-Token': csrfToken
      }
    });

    return next.handle(modifiedReq);
  }

  private getCsrfToken(): string {
    // Retrieve CSRF token from cookie or local storage
    return document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/, "$1");
  }
}
